module.exports = __webpack_public_path__ + "static/media/comfortaa-variablefont_wght-webfont.321b00c6.woff2";